import { motion } from "framer-motion";
import styled from "styled-components";

export const StyledPartnerInfo = styled(motion.div)`
 /* flex: 1 0 333px; */

`;